<template>
  <div id="login">
    <div class="login-title">
      <div class="titleCon">
        <span class="titleImg">
          <img src="../../static/image/logo-l.png" />
        </span>
        <span class="title">中能智为监控系统</span>
        <span class="pro">专业版</span>
      </div>
    </div>
    <div class="loginBox">
      <div class="welcome">
        <Icon type="md-log-in" />
        <span>欢迎登录</span>
      </div>

      <div class="p-20">
        <Form ref="loginForm" :rules="ruleValidate" :model="loginForm">
          <FormItem prop="account">
            <Input v-model="loginForm.account" size="large" placeholder="请输入用户名">
              <Button slot="prepend" icon="md-person" disabled size="small"></Button>
            </Input>
          </FormItem>

          <FormItem prop="password">
            <Input v-model="loginForm.password" size="large" type="password" placeholder="请输入密码">
              <Button slot="prepend" icon="md-lock" disabled size="small"></Button>
            </Input>
          </FormItem>

          <Button type="primary" @click="myLogin" :loading="loading" size="large" long>登录</Button>
        </Form>

        <div class="appBox">
          <fieldset>
            <legend align="center">手机APP下载</legend>
            <Row>
              <!--<Col span="12"> <div class="stayAnd">敬请期待 </div><p>Android</p></Col>-->
              <Col span="12">
                <img src="./../../static/image/android.png" />
                <p>Android</p>
              </Col>
              <Col span="12">
                <img src="./../../static/image/ios.png" />
                <p>iOS</p>
              </Col>
            </Row>
          </fieldset>
          <div class="ew float-l"></div>
          <div class="ew float-l"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RULE from "../../static/js/rule.js";
import { siteCount } from "@/api/Map";
import { mapMutations } from "vuex";
export default {
  name: "login",
  data() {
    return {
      loginForm: {
        account: "",
        password: ""
      },
      ruleValidate: RULE.ruleValidate,
      loading: false,
      myStorage: ""
    };
  },
  created: function() {
    //实例被创建之后执行代码
    let that = this;
    document.onkeydown = function(e) {
      var key;
      key = e.keyCode;
      if (key == 13) {
        that.myLogin();
      }
    };
  },
  computed: {
    //计算属性
  },
  components: {
    //组件的引用
  },
  methods: {
    //方法
    myLogin() {
      //信息验证
      this.loading = true;
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          this.login();
        } else {
          this.loading = false;
          this.$Message.error("请正确填写信息!");
        }
      });
    },
    login() {
      //登录请求
      let data = {
        account: this.loginForm.account,
        password: this.loginForm.password,
        validDays: 7,
        productCode: "MON_PRO"
      };

      this.$http.post("/ucms/user/login", data).then(ret => {
        if (ret.data.errcode == 81015) {
          this.loading = false;
          this.$Message.error({
            content: "公司未购买此产品",
            duration: 3
          });
        } else if (ret.data.errcode == 21011) {
          this.loading = false;
          this.$Message.error({
            content: "账号已锁定，请稍后重试",
            duration: 3
          });
        } else if (ret.data.errcode == 0) {
          let myData = ret.data.body;

          localStorage.setItem("userInfo", JSON.stringify(myData));
          this.$store.state.userId = myData.id;
          this.$store.state.companyId = myData.companyId;

          var curTime = new Date().getTime();
          document.cookie =
            "accessToken_cookie=" +
            escape(ret.data.body.accessTokenCookie) +
            ";domain=.znzw.net";
          document.cookie =
            "com.zndl.base.user.id=" +
            escape("1234567890123" + myData.id) +
            ";domain=.znzw.net";

          this.$router.push("/Home");
          this.loading = false;
          localStorage.setItem("companyId", myData.companyId);
          mapMutations("setCompanyId", { companyId: myData.companyId });
          siteCount(null, res => {
            if (res.data.errcode == 0) {
              localStorage.setItem("siteCount", res.data.body);
              mapMutations("setSiteCount", { siteCount: res.data.body });
            }
          });
        } else {
          this.loading = false;
          this.$Message.error({
            content: "账号或密码不匹配",
            duration: 3
          });
        }
      });
    }
  },
  mounted() {
    // 页面进入时加载内容
    this.$Notice.destroy();
  },
  watch: {
    //监测变化
  }
};
</script>
<style lang="scss">
#login {
  width: 100%;
  height: 100vh;
  min-width: 1150px;
  min-height: 800px;
  background-image: url(../../static/image/log_bg.png);
  background-repeat: no-repeat;
  background-size: 100%;

  .login-title {
    height: 80px;
    line-height: 80px;
    background-color: #ffffff;

    .titleCon {
      width: 1200px;
      margin: 0 auto;
      .titleImg img {
        margin-bottom: 13px;
      }
      .title {
        font-size: 28px;
        font-weight: 600;
        letter-spacing: 2px;
      }
      .pro {
        width: 68px;
        height: 29px;
        display: inline-block;
        border-radius: 5px;
        background-color: #3778c6;
        line-height: 29px;
        margin-left: 14px;
        color: #ffffff;
        font-size: 17px;
        text-align: center;
        position: relative;
        top: -3px;
      }
    }
  }

  .loginBox {
    width: 374px;
    height: 447px;
    float: right;
    margin-top: 130px;
    margin-right: 200px;
    border: 1px solid #efefef;
    text-align: center;
    background-color: #ffffff;
    border-radius: 5px;
  }
  .welcome {
    height: 65px;
    line-height: 65px;
    text-align: left;
    padding: 0 20px;
    border-bottom: 1px solid #f0f1f2;
    margin-bottom: 5px;
    i {
      font-size: 20px;
    }
    span {
      font-size: 20px;
      font-weight: bold;
    }
  }
  form {
    .ivu-form-item {
      margin-bottom: 30px;
    }
    .ivu-form-item:nth-of-type(2) {
      margin-bottom: 20px;
    }
    .ivu-form-item:nth-of-type(3) {
      margin-bottom: 10px;
    }
    .ivu-input {
      height: 40px;
    }
    .ivu-icon {
      font-size: 20px;
    }
    .ivu-checkbox-group {
      text-align: left;
    }
  }

  .appBox {
    margin-top: 25px;

    img {
      margin: 12px 0 8px;
      width: 55%;
    }
    p {
      width: 55%;
      text-align: center;
      margin-left: 30px;
    }
    .stayAnd {
      margin: 12px 0 8px;
      height: 90px;
      line-height: 90px;
      width: 55%;
      text-align: center;
      margin-left: 30px;
      background: #e8eaec;
      color: #c5c8ce;
    }
    fieldset {
      border: none;
      border-top: 1px solid #dddee1;

      legend {
        padding: 0 15px;
      }
    }
  }
}
</style>
